import { createContext } from 'react';

import { WidgetSitePanelSaveHandler } from '@/components/widgetConfigSiteTabbedShell/widgetConfigSiteTabbedShell/widgetConfigSiteTabbedShell.types.ts';
import { useRequiredContext } from '@/hooks';

export type WidgetSiteTabbedShellContextValue = {
  defaultSiteKey: string | undefined;
  activeSiteKey: string | undefined;
  setActiveSiteKey: (siteKey: string) => void;
  registerSave: (siteKey: string, save: WidgetSitePanelSaveHandler) => () => void;
  saveActivePanel: () => void;
  /** Resolved config-session id for `useLayoutProps` (layout id when editing, draft uuid when adding). */
  shellWidgetId: string;
};

export const WidgetSiteTabbedShellContext = createContext<
  WidgetSiteTabbedShellContextValue | undefined
>(undefined);

export const useWidgetSiteTabbedShellCtx = () =>
  useRequiredContext({
    context: WidgetSiteTabbedShellContext,
    hookName: 'useWidgetSiteTabbedShell',
    providerName: 'WidgetSiteTabbedShellProvider',
  });
